import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { createPalabraClave, deletePalabraClave, getPalabrasClave, editPalabraClave } from "../../Services/etiquetas_service";
import { filterTwoArrays } from '../../Services/functions_service'

const initialState = {
    palabrasClave: [],
    palabraClave: {
        nombre: '',
        estado: 1,
        usuario: '',
    },
    palabrasClaveSeleccionadas: [],
    palabrasClaveAsignadas: [],
}

export const palabraClaveSlice = createSlice({
    name: 'etiqueta',
    initialState,
    reducers: {
        setPalabrasClave: (state, action) => {
            state.palabrasClave = action.payload;
        },
        setPalabraClave: (state, action) => {
            state.palabraClave = action.payload;
        },
        setPalabrasClaveSeleccionadas: (state, action) => {
            state.palabrasClaveSeleccionadas = action.payload;
        },
        setPalabrasClaveAsignadas: (state, action) => {
            state.palabrasClaveAsignadas = action.payload;
        },
    }
});

export const fetchPalabrasClave = createAsyncThunk(
    'etiqueta/fetchPalabrasClave',
    async (_, { dispatch }) => {
        const etiquetaRes = await getPalabrasClave();
        dispatch(setPalabrasClave(etiquetaRes ? etiquetaRes : []));
    }
);

export const fetchPalabrasClaveAsignadas = createAsyncThunk(
    'etiqueta/fetchPalabrasClaveAsignadas',
    async (data, { dispatch }) => {
        const etiquetaRes = await getPalabrasClave();
        const asignadas = [];
        if (data.etiquetas) {
            data.etiquetas.split(',').map(asg => {
                let item = {
                    nombre: asg,
                }

                asignadas.push(item);
            });
        }
        dispatch(setPalabrasClave(asignadas ? filterTwoArrays(etiquetaRes, asignadas, "nombre") : etiquetaRes));
        dispatch(setPalabrasClaveAsignadas(asignadas ? asignadas : []));
    }
);

export const addPalabraClave = createAsyncThunk(
    'etiqueta/create',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const etiquetaRes = await createPalabraClave(data);
        dispatch(setResponse(etiquetaRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setPalabraClave(initialState.palabraClave));
        dispatch(setToast(true));
        dispatch(fetchPalabrasClave());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const EditPalabraClave = createAsyncThunk(
    'etiqueta/update',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const etiquetaRes = await editPalabraClave(data);
        dispatch(setResponse(etiquetaRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setPalabraClave(initialState.palabraClave));
        dispatch(setToast(true));
        dispatch(fetchPalabrasClave());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const DisablePalabraClave = createAsyncThunk(
    'etiqueta/delete',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const etiquetaRes = await deletePalabraClave(data);
        dispatch(setResponse(etiquetaRes));
        dispatch(setLoading(false));
        dispatch(setToast(true));
        dispatch(fetchPalabrasClave());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);




export const { setPalabrasClave, setPalabraClave, setPalabrasClaveSeleccionadas, setPalabrasClaveAsignadas } = palabraClaveSlice.actions;
export default palabraClaveSlice.reducer;